/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive} from '@angular/core';
import {WillyWonka} from '../../utils/chocolate/willy-wonka';
export class MainContainerWillyWonka extends WillyWonka {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-main-container"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MainContainerWillyWonka_tsickle_Closure_declarations() {
/** @type {?} */
MainContainerWillyWonka.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainContainerWillyWonka.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
